import PropTypes from 'prop-types';
import StructuredContent from '@nerdwallet/structured-content-core';

import { AnalyticsContextProvider } from '@nerdwallet/structured-content/contexts/AnalyticsContext';
import {
  useSegmentAnalytics,
  useAnalyticsPageView,
} from '@nerdwallet/seo-analytics';
import UniversalContainer from '../universal-container';
import {
  stringInputSpec,
  stringSelectSpec,
  wrapper,
} from '../../lib/editing-configs';

const FIELD_NAME = 'retirementCalculator';

function getProps(key, props) {
  if (props[key]) return props[key];
  return props;
}

function RetirementCalculatorSC(props) {
  const { container, anchorLink, layoutType } = getProps(FIELD_NAME, props);
  const { pageViewId, pageViewReady, pageName } = useAnalyticsPageView();
  const segmentInstance = useSegmentAnalytics();

  const analytics = {
    segmentAttributes: {
      driverPageName: pageName,
      pageViewId,
      pageViewReady,
      segmentInstance: segmentInstance.analytics,
    },
  };

  return (
    <AnalyticsContextProvider value={analytics}>
      <UniversalContainer {...container} data-testid="RetirementCalculatorSC">
        <StructuredContent>
          {{
            type: 'RetirementCalculator',
            version: '1.0.0',
            props: {
              anchorLink,
              layoutType,
            },
          }}
        </StructuredContent>
      </UniversalContainer>
    </AnalyticsContextProvider>
  );
}

RetirementCalculatorSC.getEditingConfig = (
  componentDocument,
  fieldName = FIELD_NAME
) => [
  wrapper([
    ...UniversalContainer.getEditingConfig(
      componentDocument,
      'Container',
      [
        'backgroundColor',
        'backgroundImage',
        'border',
        'margin',
        'padding',
        'hide',
        'jumpLinkId',
      ],
      `${fieldName}.container`
    ),
    stringInputSpec(`${fieldName}.anchorLink`, 'Anchor Link'),
    stringSelectSpec(
      `${fieldName}.layoutType`,
      'Layout Type',
      [
        {
          value: 'wide',
          label: 'Wide (default)',
        },
        {
          value: 'narrow',
          label: 'Narrow',
        },
      ],
      {
        help: 'Calculator layout type',
      }
    ),
  ]),
];

RetirementCalculatorSC.displayName = 'Retirement calculator SC';

RetirementCalculatorSC.propTypes = {
  retirementCalculator: PropTypes.object,
  container: PropTypes.object,
  anchorLink: PropTypes.string,
  layoutType: PropTypes.string,
};

export default RetirementCalculatorSC;
